<script lang="ts" setup>
import type { IArticleCategory } from '~/api/article';
import Side from '../components/Side.vue';
import Banner from './components/Banner.vue';
import Lists from './components/Lists.vue';
import type { IArticleFilterParams } from '~/api/types/filter';
import useSeo from './seo';

const route = useRoute()
const { mainId, subId } = route.params
const { article } = useApi()
const articleStore = useArticleStore()
const categories = computed(() => articleStore.ecoCategories)
if (categories.value.length === 0) {
  const { data: categoryData } = await article.getArticleCategories('articleEcolife')
  articleStore.setArticleCategories('eco', categoryData.value?.data as IArticleCategory[])
}

const filter = {
  category_id: subId || mainId,
  page: 1,
  per_page: 9,
} as IArticleFilterParams
const { data: articleData, execute } = await article.getArticleEcolifes(filter)
const articleRes = computed(() => articleData.value?.data.list)
const topArticleRes = computed(() => articleData.value?.data.top || [])

watch(
  () => route.query.page,
  (page) => {
    filter.page = parseInt(page as string) || 1
    execute()
    window.scrollTo(0, 0)
  }
)

const currentCategory = computed(() => {
  const mainCategory = categories.value.find((o) => o.id.toString() === mainId)
  const subCategory = mainCategory?.children?.find((o) => o.id.toString() === subId)

  return subCategory || mainCategory
})

useSeo(currentCategory.value)
</script>

<template>
  <section class="section">
    <div class="section__left">
      <div class="section__left__inner">
        <Side :data="categories" :current-category-id="subId || mainId" />
      </div>
    </div>
    <div class="section__right">
      <div class="section__banner" v-if="topArticleRes?.length > 0">
        <Banner :data="topArticleRes" />
      </div>
      <div class="section__lists">
        <Lists :data="articleRes" />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.section {
  @include grid;

  @include max-media(960) {
    @include grid(4, 24);
  }

  &__left {
    position: relative;
    grid-column: 1 / span 2;

    @include min-media(961) {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    @include max-media(960) {
      grid-column: 1 / span 4;
    }

    &__inner {
      @include min-media(961) {
        position: fixed;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
    }
  }

  &__right {
    min-height: toRem(500);
    grid-column: 4 / span 8;

    @include max-media(960) {
      grid-column: 1 / span 4;
    }
  }

  &__banner {
    margin-bottom: toRem(56);
  }
}
</style>
